import { render } from "./Tweet.vue?vue&type=template&id=2f112ad3&scoped=true"
import script from "./Tweet.vue?vue&type=script&lang=js"
export * from "./Tweet.vue?vue&type=script&lang=js"

import "./Tweet.vue?vue&type=style&index=0&id=2f112ad3&scoped=true&lang=scss"

import exportComponent from "/Users/leopons/Desktop/1_bm_dev/bubblemaps-showcase/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f112ad3"]])

export default __exports__